export const REQUEST_KNOW_THE_HOST_SECTIONS_FETCH_EM = "REQUEST_KNOW_THE_HOST_SECTIONS_FETCH_EM"
export const FETCH_KNOW_THE_HOST_SECTIONS_EM_SUCCESS = "FETCH_KNOW_THE_HOST_SECTIONS_EM_SUCCESS"
export const FETCH_KNOW_THE_HOST_SECTIONS_EM_FAILURE = "FETCH_KNOW_THE_HOST_SECTIONS_EM_FAILURE"

export const CLEAR_FETCH_KNOW_THE_HOST_SECTIONS_EM_STATES = "CLEAR_FETCH_KNOW_THE_HOST_SECTIONS_EM_STATES"